/* eslint-disable no-console */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["ERROR"] = 0] = "ERROR";
    LogLevel[LogLevel["WARN"] = 1] = "WARN";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
})(LogLevel || (LogLevel = {}));
export class Logger {
    static instance;
    level;
    constructor(level = LogLevel.INFO) {
        this.level = level;
    }
    static getInstance() {
        if (!Logger.instance) {
            // Check environment variable for log level
            const envLevel = process.env.MCP_LOG_LEVEL?.toUpperCase();
            let level = LogLevel.INFO;
            switch (envLevel) {
                case 'ERROR':
                    level = LogLevel.ERROR;
                    break;
                case 'WARN':
                    level = LogLevel.WARN;
                    break;
                case 'INFO':
                    level = LogLevel.INFO;
                    break;
                case 'DEBUG':
                    level = LogLevel.DEBUG;
                    break;
            }
            Logger.instance = new Logger(level);
        }
        return Logger.instance;
    }
    setLevel(level) {
        this.level = level;
    }
    error(message, ...args) {
        if (this.level >= LogLevel.ERROR) {
            console.error(`[MCP] ERROR: ${message}`, ...args);
        }
    }
    warn(message, ...args) {
        if (this.level >= LogLevel.WARN) {
            console.error(`[MCP] WARN: ${message}`, ...args);
        }
    }
    info(message, ...args) {
        if (this.level >= LogLevel.INFO) {
            console.error(`[MCP] INFO: ${message}`, ...args);
        }
    }
    debug(message, ...args) {
        if (this.level >= LogLevel.DEBUG) {
            console.error(`[MCP] DEBUG: ${message}`, ...args);
        }
    }
    // Helper method to check if a certain level is enabled
    isEnabled(level) {
        return this.level >= level;
    }
}
// Export singleton instance
export const logger = Logger.getInstance();
